import { gql, useClient } from 'urql';

import { useElasticIndexPrefix } from '@/contexts';
import { useQueryParams } from '@/hooks';
import { downloadFile, mapVariables } from '@/utils';
import {
  PlayerPaymentsReportQuery,
  PlayerPaymentsReportQueryVariables,
} from './__generated__/usePlayerPaymentsReport';
import { queryParams } from './queryParams';

const PLAYER_PAYMENTS_REPORT_QUERY = gql`
  query PlayerPaymentsReport(
    $brand: BrandEnum
    $currency: String
    $desc: Boolean
    $from: OffsetDateTime
    $gameProviderId: GameProvider
    $id: String
    $indexPrefix: String
    $orderBy: PaymentSearchOrder
    $org: OrgEnum
    $paymentStatus: PaymentStatus
    $paymentType: PaymentType
    $playerId: ID!
    $rawId: String
    $sessionId: String
    $to: OffsetDateTime
  ) {
    viewer {
      id
      exportedPayments(
        brand: $brand
        currency: $currency
        desc: $desc
        from: $from
        gameProviderId: $gameProviderId
        id: $id
        indexPrefix: $indexPrefix
        orderBy: $orderBy
        org: $org
        paymentStatus: $paymentStatus
        paymentType: $paymentType
        playerId: $playerId
        rawId: $rawId
        sessionId: $sessionId
        to: $to
      ) {
        url
      }
    }
  }
`;

export default function usePlayerPaymentsReport(playerId: string) {
  const [query] = useQueryParams(queryParams);
  const client = useClient();

  const { indexPrefix } = useElasticIndexPrefix();

  const generate = async () => {
    const variables: PlayerPaymentsReportQueryVariables = {
      ...mapVariables(query),
      indexPrefix,
      playerId,
    };

    return client
      .query<PlayerPaymentsReportQuery, PlayerPaymentsReportQueryVariables>(
        PLAYER_PAYMENTS_REPORT_QUERY,
        variables,
      )
      .toPromise()
      .then(async (res) => {
        const url = res.data?.viewer.exportedPayments.url;

        if (url) {
          await downloadFile(url, {
            fileName: 'player-payments-report.csv',
          });
        }
      });
  };

  return {
    generate,
  };
}
